import React, { useRef, useState } from 'react';
import { Tooltip } from 'antd';
import { Icon } from '@docs/kd-d2c-components';
import DebugPanel from './DebugPanel';
import './Header.less';
import { RefreshButton } from '@src/components/pc/RefreshButton';
import { useDebugMode } from '@/hooks/useDebugMode';
import { eed_mario_icon_arrowfor_line } from '@src/assets/icons';

interface ClawChatHeaderProps {
  title?: string;
  onShare?: () => void;
  shareMode?: boolean;
  /** 无选中会话（新建会话页）时为 false，不展示分享入口 */
  showShareButton?: boolean;
}

const ClawChatHeader: React.FC<ClawChatHeaderProps> = ({
  title = '',
  onShare,
  shareMode,
  showShareButton = true,
}) => {
  const [debugOpen, setDebugOpen] = useState(false);

  // ── 暗门：连续点击标题 5 次 ────────────────────────────────────────────────
  const clickCountRef = useRef(0);
  const clickTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const { toggleDebugMode } = useDebugMode();
  const handleTitleClick = () => {
    clickCountRef.current += 1;
    if (clickTimerRef.current) clearTimeout(clickTimerRef.current);
    if (clickCountRef.current >= 5) {
      clickCountRef.current = 0;
      setDebugOpen((v) => !v);
      toggleDebugMode(true);
      return;
    }
    clickTimerRef.current = setTimeout(() => {
      clickCountRef.current = 0;
    }, 2000);
  };

  return (
    <div className="claw-chat-header">
      <div
        className="claw-chat-header-title"
        onClick={shareMode ? undefined : handleTitleClick}
        style={{ cursor: 'default', userSelect: 'none' }}
      >
        {shareMode ? '选择分享' : title}
      </div>
      <div
        className="claw-chat-header-actions"
        style={shareMode ? { opacity: 0, pointerEvents: 'none' } : undefined}
      >
        <RefreshButton />
        {showShareButton && (
          <Tooltip title="分享" placement="top">
            <span className="claw-chat-header-share-btn" onClick={onShare}>
              <Icon icon={eed_mario_icon_arrowfor_line} size={20} />
            </span>
          </Tooltip>
        )}
      </div>

      {debugOpen && <DebugPanel onClose={() => {
        setDebugOpen(false);
        toggleDebugMode(false);
      }} />}
    </div>
  );
};

export default ClawChatHeader;
